export const UNIVERSITY_FRONTEND_DASHBOARD_URL = `${process.env.REACT_APP_UNIVERSITY_FRONTEND_URL}/dashboard`;
export const UNIVERSITY_FRONTEND_AUTH_URL = `${process.env.REACT_APP_UNIVERSITY_FRONTEND_URL}/auth`;

export const COURSE_NAME_TO_COURSE_URL_MAPPING = {
    RENAISSANCE: "/crack-coding-interviews",
    LOW_LEVEL_DESIGN: "/low-level-design",
    DSA_ESSENTIALS: "/dsa-and-algorithms-essentials",
    BEGIN_WITH_CPP: "/begin-with-c++",
    BEGIN_WITH_PYTHON: "/begin-with-python",
    JAVA_SPRING_BOOT: "/java-springboot",
    FULL_STACK_DEVELOPMENT: "/become-a-frontend-engineer",
};

export const COURSE_URL_TO_DASHBOARD_COURSE_IDENTIFIER_MAPPING = {
    [COURSE_NAME_TO_COURSE_URL_MAPPING.RENAISSANCE]: "renaissance",
    [COURSE_NAME_TO_COURSE_URL_MAPPING.LOW_LEVEL_DESIGN]: "low-level-design",
    [COURSE_NAME_TO_COURSE_URL_MAPPING.DSA_ESSENTIALS]: "crash-course",
    [COURSE_NAME_TO_COURSE_URL_MAPPING.BEGIN_WITH_CPP]: "cpp",
    [COURSE_NAME_TO_COURSE_URL_MAPPING.BEGIN_WITH_PYTHON]: "python",
    [COURSE_NAME_TO_COURSE_URL_MAPPING.JAVA_SPRING_BOOT]: "java-springboot",
    [COURSE_NAME_TO_COURSE_URL_MAPPING.FULL_STACK_DEVELOPMENT]: "react",
};
